export default {
  allTractContents: (state) => state.tractContents
}
